<script>
  import InvestorLayout from './components/MenuList'
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  import 'swiper/dist/css/swiper.css'
  import File from '@components/List/File'

  export default {
    page() {
      return {
        title: `財務資訊 | 投資人專區`,
      }
    }, 
    components: {
      InvestorLayout,
      swiper,
      swiperSlide,
      File,
    },
    props: {
      defaultValue: {
        type: Object,
        default: () => {
        }
      },
      investorFinance: {
        type: Object,
        default: () => {
        }
      }
    },
    data() {
      const $self = this;
      const DEFAULT_PAGE_COUNT = 1;
      return {
        /* list:[
         {
         title:'109',
         value: [
         {
         title: '109Q1-IFRSs合併財報',
         file: 'test.pdf'
         },
         {
         title: '109Q2-IFRSs合併財報',
         file: 'test.pdf'
         },
         {
         title: '109Q3-IFRSs合併財報',
         file: 'test.pdf'
         },
         {
         title: '109Q4-IFRSs合併財報',
         file: 'test.pdf'
         },
         ]
         },
         {
         title:'108',
         value: [
         {
         title: '108Q1-IFRSs合併財報',
         file: 'test.pdf'
         },
         ]
         },
         {
         title:'107',
         value: [
         {
         title: '107Q1-IFRSs合併財報',
         file: 'test.pdf'
         },
         {
         title: '107Q2-IFRSs合併財報',
         file: 'test.pdf'
         },
         {
         title: '107Q4-IFRSs合併財報',
         file: 'test.pdf'
         }
         ]
         },
         {
         title:'106',
         value: [
         {
         title: '106Q1-IFRSs合併財報',
         file: 'test.pdf'
         },
         {
         title: '106Q2-IFRSs合併財報',
         file: 'test.pdf'
         },
         {
         title: '106Q3-IFRSs合併財報',
         file: 'test.pdf'
         },
         {
         title: '106Q4-IFRSs合併財報',
         file: 'test.pdf'
         },
         {
         title: '106Q4-IFRSs合併財報',
         file: 'test.pdf'
         }
         ]
         },
         {
         title:'105',
         value: [
         {
         title: '105Q1-IFRSs合併財報',
         file: 'test.pdf'
         },
         {
         title: '105Q2-IFRSs合併財報',
         file: 'test.pdf'
         },
         {
         title: '105Q3-IFRSs合併財報',
         file: 'test.pdf'
         },
         ]
         },
         {
         title:'104',
         value: [
         {
         title: '104Q1-IFRSs合併財報',
         file: 'test.pdf'
         },
         {
         title: '104Q2-IFRSs合併財報',
         file: 'test.pdf'
         },
         {
         title: '104Q4-IFRSs合併財報',
         file: 'test.pdf'
         }
         ]
         }
         ], */
        swiperOption: {
          slidesPerView: 5,
          speed: 600,
          slidesPerGroup: 1,
          spaceBetween: 20,
          centeredSlides: true,
          shortSwipes: false,
          initialSlide: DEFAULT_PAGE_COUNT - 1,
          breakpoints: {
            768: {
              slidesPerView: 1,
            },
          },
          on: {
            slideChange() {
              const index = (this.activeIndex % $self.list.length) || 0;
              $self.setSlide(index)
            }
          },
        },
        swiperOptionEvent: {
          slidesPerView: 1,
          speed: 600,
          slidesPerGroup: 1,
          spaceBetween: 0,
          centeredSlides: true,
          allowTouchMove: false,
          initialSlide: DEFAULT_PAGE_COUNT - 1,
        },
      }
    },
    computed: {
      list() {
        if(this.defaultValue) {
          return Object.keys(this.defaultValue)
          .map((year) => {
            const fileList = []
            this.defaultValue[year].forEach(({ files,title }) => {
              const fileItem = []
              files.forEach((item) => {
                fileItem.push({
                  ...item,
                  title: title
                })
              })
              fileList.push(...fileItem)
            })
            return {
              title: year,
              value: fileList.map((file) => ({
                ...file,
                title: file.title,
                file: file.downloadLink
              }))
            }
          })
          .sort((a, b) => b.title - a.title)   // 時間從近至遠
        } else {
          return []
        }
        
      }
    },
    methods: {
      setSlide(index) {
        // console.log(index);
        this.$refs.carouselYear.swiper.slideTo(index, 600)
        this.$refs.carouselEvent.swiper.slideTo(index, 600)
      },
      onNext() {
        this.$refs.carouselYear.swiper.slideNext()
      },
      onPrev() {
        this.$refs.carouselYear.swiper.slidePrev()
      },
    },
  }
</script>
<template>
  <InvestorLayout>
    <div :class="$style.pageFiance">
      <section class="container section sectionAnnouncement text-center">
        <template  v-if="investorFinance.revenue">
          <BaseSectionTitle title="月營收公告"/>
          <p class="mb-5">零壹科技股份有限公司月營收公告資訊，請參閱以下連結：</p>
          <div class="sectionAnnouncement__link">
            <a
              class="color-primary link d-flex flex-column justiy-content-center align-items-center"
              :href="investorFinance.revenue"
              target="_blank"
            >
              <img
                :src="require(`@src/assets/images/investor/financeIcon.svg`)"
                alt=""
                class="mb-2"
                width="76"
              >
              <span class="text-sm md:text-lg">零壹月營收公告 (股票代碼：3029)</span>
            </a>
          </div>
        </template>
      </section>
      <section  v-if="list.length > 0" class="section sectionInfo">
        <div class="container">
          <BaseSectionTitle title="歷年財務資訊" class="text-center"/>
          <div class="carouselYear">
            <swiper
              v-if="list.length > 0"
              ref="carouselYear"
              :options="swiperOption"
              class="carouselYear__list"
            >
              <swiper-slide
                v-for="(item, $index) in list"
                :key="$index"
                class="carouselYear__item"

              >
                <div
                  class="carouselYear__item--boxInner text-center"
                  @click="setSlide($index)"
                  @keydown="setSlide($index)"
                >
                  <!-- <span class="color-primary">{{$index}}- </span> -->
                  <span class="year">{{ item.title }}</span>
                </div>
              </swiper-slide>
            </swiper>
            <!--<div class="navigationBox">
              <button class="navigationBtn isPrev swiper-button swiper-button-prev" @click="onPrev">
                <svg xmlns="http://www.w3.org/2000/svg" height="12.483" viewBox="0 0 49.974 12.483" width="49.974"><g fill="none" stroke="#2A2F35" stroke-linecap="round"><path d="m0 0h48.5" transform="matrix(-1 0 0 -1 49.474 6.242)"/><path d="m0 0 5.535 5.535" transform="matrix(-1 0 0 -1 6.241 11.777)"/><path d="m0 5.535 5.535-5.535" transform="matrix(-1 0 0 -1 6.241 6.242)"/></g></svg>
              </button>
              <button class="navigationBtn isNext swiper-button swiper-button-next" @click="onNext">
                <svg xmlns="http://www.w3.org/2000/svg" height="12.483" viewBox="0 0 49.974 12.483" width="49.974"><g fill="none" stroke="#2A2F35" stroke-linecap="round"><path d="m0 0h48.5" transform="matrix(-1 0 0 -1 49.474 6.242)"/><path d="m0 0 5.535 5.535" transform="matrix(-1 0 0 -1 6.241 11.777)"/><path d="m0 5.535 5.535-5.535" transform="matrix(-1 0 0 -1 6.241 6.242)"/></g></svg>
              </button>
            </div>-->
            <div
              :class="$style.navigation"
            >
              <button
                class="navigation__btn navigation__prev"
                @click="onPrev"
              >
                <i class="navigation__icon iconoom icon-arrow d-md-block d-none"></i>
                <i class="navigation__icon fal fa-chevron-left d-md-none d-block"></i>
              </button>
              <button
                class="navigation__btn navigation__next"
                @click="onNext"
              >
                <i class="navigation__icon iconoom icon-arrow d-md-block d-none"></i>
                <i class="navigation__icon fal fa-chevron-left d-md-none d-block"></i>

              </button>
            </div>
          </div>
          <div class="carouselEvent">
            <swiper
              ref="carouselEvent"
              :options="swiperOptionEvent"
              class="carouselEvent__list"
            >
              <swiper-slide
                v-for="(year, label, $index) in list"
                :key="$index"
                class="carouselEvent__item"
              >
                <div class="row event_list">
                  <div
                    v-for="(item,$index2) in year.value"
                    :key="$index2"
                    class="col-md-6 event_item"
                  >
                    <File
                      :item="item"
                      class="file"
                    />
                  </div>
                </div>
              </swiper-slide>
            </swiper>
          </div>
        </div>
      </section>
    </div>
  </InvestorLayout>
</template>
<style lang="scss" module>
  .pageFiance {
    :global {
      .sectionAnnouncement {
        &__link {
          padding: 4.125rem;
          border: 1px solid $color-gray-3;
          border-radius: 2px;

          @include max-md {
            padding: 3rem $container-gap;
          }
        }

        .link {
          text-decoration: underline;
          transition: .3s;

          &:hover {
            color: $color-primary-hover;
          }
        }
      }

      .sectionInfo {
        background: $color-gray-2;

        .carouselYear {
          position: relative;

          &__list {
            position: relative;
            width: 80%;
            margin-right: auto;
            margin-bottom: 2.5rem;
            margin-left: auto;

            &::before {
              position: absolute;
              top: 75%;
              right: $container-gap;
              left: $container-gap;
              height: 1px;
              content: '';
              background: rgba(177, 186, 202, 1);
            }
          }

          &__item {
            height: 133px;
            padding-top: 45px;

            .year {
              &:hover {
                color: $color-primary-hover;
                cursor: pointer;
              }
            }

            &.swiper-slide {
              position: relative;

              &::before {
                position: absolute;
                bottom: 25%;
                left: 50%;
                width: 1px;
                height: 10px;
                content: '';
                background: rgba(177, 186, 202, 1);
                transform: translateX(-50%);
              }

              &-active {
                &::before {
                  bottom: 20%;
                  width: 12px;
                  height: 12px;
                  content: '';
                  background: $color-primary;
                  border-radius: 100%;
                }
              }
            }
          }

          .navigationBox {
            position: absolute;
            top: 71.8%;
            left: 0;
            z-index: 1;
            width: 100%;
            margin-bottom: 30px;
          }

          .swiper-button {
            &:focus {
              outline: none;
            }

            &-prev {
            }

            &-next {
              transform: rotate(180deg);
            }

            color: $color-gray-7;
            border: 0;
          }
        }

        .carouselEvent {
          width: 66%;
          margin: 0 auto;

          @include max-md {
            width: 100%;
          }

          &__list {
            margin-top: -40px;
            @include max-md {
              margin-top: -20px;
            }
          }

          &__item {
            min-height: 200px;

            .event_item {
              margin-top: 40px;
              @include max-md {
                margin-top: 20px;
              }
            }
          }
        }
      }
    }
  }

  .navigation {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    height: 100%;
    margin-top: 2.1rem;
    pointer-events: none;

    :global {
      .navigation {
        &__btn {
          position: absolute;
          top: 50%;
          z-index: 0;
          display: flex;
          width: 6rem;
          height: 100%;
          pointer-events: auto;
          background: transparent;
          border: unset;
          transform: translateY(-50%);
          appearance: none;

          &:focus {
            outline: none;
          }

          &:hover {
            .navigation {
              &__icon {
                color: $color-primary;
                border-color: $color-primary;

                @include max-md {
                  color: #FFF;
                  background: $color-primary;
                }
              }

            }
          }

          &:active {
            outline: none;

            .navigation {
              &__icon {
                color: $color-primary;
                border-color: $color-primary;

                @include max-md {
                  color: #FFF;
                  background: $color-primary;
                }
              }
            }
          }
        }

        &__prev {
          left: 0;
          align-items: center;
          justify-content: flex-start;
        }

        &__next {
          right: 0;
          align-items: center;
          justify-content: flex-end;

          .navigation__icon {
            transform: rotateY(180deg);
          }
        }

        &__icon {
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 3rem;
          color: $color-gray-7;
          transition: background 0.3s;
          transition: .3s;

          @include max-md {
            width: 40px;
            height: 40px;
            font-size: 1.25rem;
            line-height: 40px;
            color: #8C97AB;
            border: unset;
            border: 1px solid #8C97AB;
            border-radius: 100%;
            box-shadow: 0 32px 84px #0E567C2A;
          }
        }
      }
    }
  }

</style>
